import React from "react";
import NotFound from "../components/NotFound";

export default function Error() {
  return <NotFound />;
}
